<template>
    <div>

        <table style="width:100%">
            <tr v-for="section in data" :key="section.id">
                <td>{{ section.quantity }}</td>
                <td>{{ section.location.name }}</td>
                <td>{{ section.service.name }} <span v-if="section.timetables.length == 1 && section.timetables[0].weekday"> ({{ section.timetables[0].weekday }})</span></td>
                <td style="text-align:right">{{ section.service.relevantPrice.price }}</td>
            </tr>
            <tr>
                <td><b>Total</b></td>
                <td></td>
                <td></td>
                <td style="text-align:right"><b>{{ total }}</b></td>
            </tr>
        </table>

    </div>
</template>
    
   

<script>

    export default {

        data: function() {
            return  {
                data: false,
            }
        },
        props: {
            session: {
                type: String,
                required: true
            },
        },
        computed: {
            total: function(){
                let total = 0;
                for(let i = 0; i < this.data.length ; i++)
                {
                   total = total +  this.data[i].service.relevantPrice.price
                }
                return total;
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            loadData() {
                let app = this;
                // load for each sector the services
                
                axios.get('/api/session/data/' + this.session )
                    .then(response => {
                        app.data = response.data.selections
                    })
                    .catch(e => {
                        this.errors.push(e)
                    });
            },
 
        }

    }
</script>
